import { inject, Injectable } from '@angular/core';
import { ApiDataAccess } from '@softline/core';
import {
  SOFTLINE_API_DELIVERY_NOTE_ROSTER_ORDERS,
  SOFTLINE_API_DELIVERY_NOTE_ROSTER_PURCHASE_ORDERS,
} from '../delivery-note-roster.api';
import { Order } from '../types/order';

@Injectable({ providedIn: 'root' })
export class DeliveryNoteRosterArtifactsRepository {
  private readonly dataAccess = inject(ApiDataAccess);

  loadOrders(): Promise<Order[]> {
    return this.dataAccess.get<Order[]>({ path: SOFTLINE_API_DELIVERY_NOTE_ROSTER_ORDERS });
  }

  loadPurchaseOrders(): Promise<Order[]> {
    return this.dataAccess.get<Order[]>({
      path: SOFTLINE_API_DELIVERY_NOTE_ROSTER_PURCHASE_ORDERS,
    });
  }
}
